import React, { Suspense, lazy } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Routes, BrowserRouter, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import 'tailwindcss/tailwind.css';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { store } from './redux/store';
import './index.css';
import '../assets/fonts/fonts.css';
import Spinner from './components/Spinner';
var App = lazy(function () { return import('./views/App'); });
import Auth from './views/Auth';
import LoadingLayer from './components/LoadingLayer';
import ErrorPage from './views/ErrorPage';
import Maintenance from './views/Maintenance';
import { ToastContainer } from './components/Toast';
!window.playwright &&
    Sentry.init({
        dsn: 'https://35dfd2837dae4745b5be7a8a8e2a98d3@o1168436.ingest.sentry.io/6260370',
        integrations: [
            new BrowserTracing(),
            new Sentry.Integrations.Breadcrumbs({
                console: true,
            }),
            new BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV6Instrumentation(React.useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes),
            }),
        ],
        tunnel: '/api/sentry',
        debug: new URLSearchParams(window.location.search).has('debug-sentry'),
        environment: process.env.NODE_ENV,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        normalizeDepth: 10,
    });
var loading = document.createElement('div');
loading.id = 'loading';
document.body.appendChild(loading);
var modal = document.createElement('div');
modal.id = 'modal';
document.body.appendChild(modal);
var lightbox = document.createElement('div');
lightbox.id = 'lightbox';
document.body.appendChild(lightbox);
var root = document.createElement('div');
root.id = 'root';
document.body.appendChild(root);
render(React.createElement(React.StrictMode, null,
    React.createElement(Sentry.ErrorBoundary, { fallback: React.createElement(ErrorPage, null) },
        React.createElement(Provider, { store: store },
            React.createElement(BrowserRouter, { basename: '/dashboard' },
                React.createElement(Suspense, { fallback: React.createElement("div", { className: 'flex h-screen w-full items-center justify-center' },
                        React.createElement(Spinner, null)) },
                    React.createElement("div", { className: 'dark' },
                        window.electron ? (React.createElement("div", { className: 'webkit-app-drag fixed h-7 w-full' })) : (React.createElement(React.Fragment, null)),
                        React.createElement(ToastContainer, null),
                        React.createElement(LoadingLayer, null),
                        process.env.MAINTENANCE_MODE ? (React.createElement(Maintenance, null)) : (React.createElement(Routes, null,
                            React.createElement(Route, { path: '/*', element: React.createElement(DndProvider, { backend: HTML5Backend },
                                    React.createElement(App, null)) }),
                            React.createElement(Route, { path: 'auth/*', element: React.createElement(Auth, null) }))))))))), document.querySelector('#root'));
